import { render, staticRenderFns } from "./FriendLink.vue?vue&type=template&id=570f4901&scoped=true"
import script from "./FriendLink.vue?vue&type=script&lang=js"
export * from "./FriendLink.vue?vue&type=script&lang=js"
import style0 from "./FriendLink.vue?vue&type=style&index=0&id=570f4901&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "570f4901",
  null
  
)

export default component.exports